<template>
  <div class="product">
    <navBar />
    <div class="p-banner" />
    <div class="p-title">
      <img class="p-header" src="https://restaskimg.civaonline.cn/imagesH5/product/header.png" alt="">
      <div class="p-title-r">
        <div class="p-title-txt">
          教师中心
        </div>
        <div class="p-title-intro">
          让老师上课更轻松，成长更迅速
        </div>
      </div>
    </div>
    <div class="p-content">
      <div class="p-content-item p-item-1">
        <img class="item-img-1" src="https://restaskimg.civaonline.cn/imagesH5/product/tea-1.png" alt="">
        <div class="p-item-text">
          <h4 class="p-item-text-title line-1">
            <span>教学横版+配套<br> 趣味课件，打造互动升级的教学环境</span>
          </h4>
          <p class="p-item-text-intro">
            多媒体课件与教学内容的自然结合，丰富多样的课程内容与线下EEC体系内容配套，加速学生的感知过程，优化教学效果
          </p>
        </div>
      </div>
      <div class="p-content-item p-item-2">
        <img class="item-img-2" src="https://restaskimg.civaonline.cn/imagesH5/product/tea-2.png" alt="">
        <div class="p-item-text">
          <h4 class="p-item-text-title line-2">
            <span>3S教学管理，将课堂还给学生</span>
          </h4>
          <p class="p-item-text-intro">
            小组管理模式，同步积分排名体系；激发学生的学习积极性，主观能动性
          </p>
        </div>
      </div>
      <div class="p-content-item p-item-3">
        <img class="item-img-3" src="https://restaskimg.civaonline.cn/imagesH5/product/tea-3.png" alt="">
        <div class="p-item-text">
          <h4 class="p-item-text-title line-3">
            <span>海量教学资源，教研备课更轻松</span>
          </h4>
          <p class="p-item-text-intro">
            CC英语24年教育资源沉淀，教学横版配套标准说课视频，让教学标准化，500+课堂小游戏倾情奉送，让课堂更生动
          </p>
        </div>
      </div>
      <div class="p-content-item p-item-4">
        <img class="item-img-4" src="https://restaskimg.civaonline.cn/imagesH5/product/tea-4.png" alt="">
        <div class="p-item-text">
          <h4 class="p-item-text-title line-4">
            <span>APP+web模式，让信息互动更便捷</span>
          </h4>
          <p class="p-item-text-intro">
            课堂动态、课堂成绩随时发送，记录孩子的学习足迹，完整沉淀阶段性学习成果，让教学成果有据可依，提升教学服务品质感
          </p>
        </div>
      </div>
      <div class="p-content-item p-item-5">
        <img class="item-img-5" src="https://restaskimg.civaonline.cn/imagesH5/product/tea-5.png" alt="">
        <div class="p-item-text">
          <h4 class="p-item-text-title line-5">
            <span>大数据分析，学情全掌握</span>
          </h4>
          <p class="p-item-text-intro">
            通过大数据分析，实时了解学生学习情况；老师实时获取班级学生分层情况，及时调整教学方向
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navBar from '@/components/navBar';
export default {
  components: {
    navBar,
  },
}
</script>

<style scoped lang="less">
    .product{
        .p-banner{
            background: url("https://restaskimg.civaonline.cn/imagesH5/t-banner.png") no-repeat center center / cover;
        }
        .p-content{
            padding: 0 32px 112px;
            .p-content-item{
                background: rgba(255,241,212,.5);
                padding-bottom: 40px;
                margin-top: 210px;
                img{
                    width: 610px;
                    margin-top: -136px;
                }
                .p-item-text{
                    margin-top: 30px;
                    .p-item-text-title:before{
                        background: #FFE37E;
                    }
                    .line-1:before{
                        width: 512px;
                    }
                    .line-2:before{
                        width: 422px;
                    }
                    .line-3:before{
                        width: 448px;
                    }
                    .line-4:before{
                        width: 496px;
                    }
                    .line-5:before{
                        width: 352px;
                    }
                    .p-item-text-intro{
                        text-align: left;
                        padding: 0 32px;
                    }
                }
            }
            .p-item-1{
                margin-top: 142px;
            }
            .p-item-2{
                img{
                    margin-top: -166px;
                }
            }
            .p-item-3{
                img{
                    width: 605px;
                    margin-top: -140px;
                }
            }
            .p-item-4{
                margin-top: 220px;
                img{
                    width: 550px;
                    margin-top: -150px;
                }
            }
            .p-item-5{
                margin-top: 254px;
                img{
                    margin-top: -184px;
                }
            }
        }
    }
</style>
